module.exports = __webpack_public_path__ + "img/loaddinglogo.2a9b1062.png";